import { type Invoice, type InvoiceQueryParams, InvoiceQueryParamsSchema, manualPaymentsEndpoints } from "../../../api";
import { useStrapiList, type UseStrapiListOptions } from "../../../hooks/strapi";
import getErrorMessage from "../../../utils/getErrorMessage";
import handleError from "../../utils/handleError";

type UseManualPaymentInvoicesProps = UseStrapiListOptions;

/**
 * Hook for fetching and managing pending manual payment invoices.
 */
const useManualPaymentInvoices = (props: UseManualPaymentInvoicesProps = {}) => {
  const {
    items: invoices,
    setItems: setInvoices,
    refresh,
    isLoading,
    ...other
  } = useStrapiList<Invoice>({
    ...props,
    load: (params) => {
      const parsed = InvoiceQueryParamsSchema.parse(params);
      return loadPendingInvoices(parsed);
    },
    onLoadError: (err: unknown) => {
      handleError(getErrorMessage(err, "Manual payment invoices loading failed"));
    },
  });

  return {
    invoices,
    setInvoices,
    refresh,
    isLoading,
    ...other,
  };
};

export const loadPendingInvoices = (params?: InvoiceQueryParams) =>
  manualPaymentsEndpoints.getPendingInvoices(params);

export default useManualPaymentInvoices;
